<template>
  <div class="user-page">
    <div class="header">
      <h1>{{ user.username }}</h1>
      <p>
        {{ user.shelfCount }}
        {{ user.shelfCount === 1 ? 'shelf' : 'shelves' }}, {{ user.bookCount }}
        {{ user.bookCount === 1 ? 'book' : 'books' }}
      </p>
    </div>
    <div class="content">
      <div v-for="shelf in shelves" :key="shelf.label">
        <shelf :shelf="shelf" :user="user" :count="20"></shelf>
      </div>
      <shelf v-if="user.username" :user="user" :count="20"></shelf>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import Shelf from '../components/Shelf';

export default {
  name: 'user',
  components: {
    shelf: Shelf,
  },
  data() {
    return {
      token: this.$cookies.get('user'),
      user: {
        username: this.$route.params.username,
      },
      shelves: [],
      tags: [],
      shelflabel: '',
    };
  },
  watch: {
    async $route() {
      await this.getUser();
      await this.getShelves();
      this.$eventHub.$emit('refresh-shelves');
    },
  },
  async mounted() {
    await this.getUser();
    this.getShelves();
  },
  methods: {
    async getShelves() {
      const response = await axios.get(`/user/${this.user.username}/shelves`, {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      });
      this.shelves = response.data;
    },
    async getUser() {
      if (this.$route.params.username) {
        const response = await axios.get(
          `/user/${this.$route.params.username}`,
        );
        this.user = response.data;
        return;
      }
      if (this.token) {
        const response = await axios.get('/user', {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        this.user = response.data;
      }
    },
    async getTags() {
      const response = await axios.get('/tags');
      this.tags = response.data.data;
    },
    async onSubmit() {
      await axios.put(
        '/shelves',
        {
          tag: this.shelflabel,
        },
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
            'Content-Type': 'application/json',
          },
        },
      );
      this.getShelves();
    },
  },
};
</script>
